export default __webpack_public_path__ + "e2b6e40b60c8bdc953f29a739267bf04.png";